<template>
  <div>
    <BlocoFiltroPesquisa
      titulo="Paciente"
      :sem-pesquisa="true"
      nome-do-form="PacienteAgendamentosForm"
    >
      <template #form>
        <div class="row">
          <div class="form-group col-xs-12 col-sm-10 col-md-8 col-lg-8">
            <CampoNome :valor="paciente.nome" :somente-leitura="true" />
          </div>
          <div class="form-group col-xs-12 col-sm-2 col-md-4 col-lg-4">
            <CampoCpf :valor="paciente.cpf" :somente-leitura="true" />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><PacienteAgendamentosTabela
          :agendamentos="agendamentos"
          @atualizar="atualizar"
      /></template>
      <template #fichas>
        <div
          v-for="agendamento in agendamentos"
          :key="agendamento._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <PacienteAgendamentosFicha
            :agendamento="agendamento"
            @atualizar="atualizar"
          />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoCpf from '@/componentes/formulario/CampoCpf'
import CampoNome from '@/componentes/formulario/CampoNome'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import PacienteServico from '@/servicos/PacienteServico'

import PacienteAgendamentosFicha from './PacienteAgendamentosFicha'
import PacienteAgendamentosTabela from './PacienteAgendamentosTabela'

const menuAtual = {
  descricao: 'Agendamentos do paciente',
  descricaoNovo: 'Novo(a)',
  breadcrumb: ['Atendimento', 'Pacientes', 'Agendamentos do paciente'],
}

export default {
  components: {
    PacienteAgendamentosFicha,
    PacienteAgendamentosTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    CampoCpf,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const agendamentos = ref([])
    const paciente = ref({
      cpf: '',
      nome: '',
    })
    const filtro = ref({
      pacienteId: '',
    })
    const servico = new PacienteServico()
    const nomeResultado = 'agendamentos'
    const pesquisa = usePesquisa({
      filtro,
      resultado: agendamentos,
      servico,
      nomeResultado,
      recuperarTotal: (filtroAtual) =>
        servico.recuperarAgendamentosTotal(filtroAtual),
      recuperarTodos: (filtroAtual) =>
        servico.recuperarAgendamentos(filtroAtual),
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(menuAtual)
    return {
      agendamentos,
      paciente,
      servico,
      filtro,
      ...pesquisa,
    }
  },

  created() {
    this.recuperarPaciente()
  },
  methods: {
    recuperarTotal() {
      return this.servico.recuperarAgendamentosTotal(this.filtro)
    },
    recuperarTodos() {
      return this.servico.recuperarAgendamentos(this.filtro)
    },
    atualizar() {
      this.pesquisar(this.filtro.skip)
    },
    recuperarPaciente() {
      if (this.$route.params.id) {
        const pacienteId = this.$route.params.id
        this.filtro.pacienteId = pacienteId
        this.servico.recuperar(pacienteId).then((result) => {
          const paciente = {
            cpf: result.paciente.docs_pessoais.cpf,
            nome: result.paciente.nome,
          }
          this.paciente = paciente
        })
      }
    },
  },
}
</script>
